module.exports = __webpack_public_path__ + "media/images/gallery/9-ff43b244b628389fc70af03e8eff473b.jpg";